// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-table-list{padding:5px;cursor:pointer;display:flex;justify-content:start;align-items:center;border:1px solid #fff}.file-table-list:hover{border:1px solid gray}.file-table-list:nth-child(even){background-color:#efefef}.file-table-list__icon{max-height:25px}", ""]);
// Exports
module.exports = exports;
